export enum ERegimesTributacao {
  SIMPLES_NACIONAL = 1,
  LUCRO_PRESUMIDO = 2,
  LUCRO_REAL = 3,
  OUTROS = 4,
}

export const ERegimesTributacaoLabels: Record<ERegimesTributacao, string> = {
  [ERegimesTributacao.SIMPLES_NACIONAL]: 'Simples Nacional',
  [ERegimesTributacao.LUCRO_PRESUMIDO]: 'Lucro Presumido',
  [ERegimesTributacao.LUCRO_REAL]: 'Lucro Real',
  [ERegimesTributacao.OUTROS]: 'Outros',
};

export const OPCOES_REGIME_TRIBUTARIO = Object.entries(ERegimesTributacaoLabels).map(([value, label]) => ({
  value: parseInt(value),
  label,
}));
